/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormDefinitionEntityError
 */
export interface FormDefinitionEntityError {
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionEntityError
     */
    code: FormDefinitionEntityErrorCodeEnum;
}

export function FormDefinitionEntityErrorFromJSON(json: any): FormDefinitionEntityError {
    return FormDefinitionEntityErrorFromJSONTyped(json, false);
}

export function FormDefinitionEntityErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDefinitionEntityError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function FormDefinitionEntityErrorToJSON(value?: FormDefinitionEntityError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

/**
* @export
* @enum {string}
*/
export enum FormDefinitionEntityErrorCodeEnum {
    NOVALIDQUESTION = 'NO_VALID_QUESTION'
}


